<script setup>

</script>

<template>
  <div v-if="telegramConfig.iframeHost && telegramConfig.botId && !isAndroidWebview" class="telegram-login-button-container" @click="telegramLogin">
    <iframe id="telegramLoginIframe" title="Telegram login" scrolling="no" style="border: 0; width: 100%; height: 100%; overflow: hidden" :src="`${telegramConfig.iframeHost}/telegram-login.html?bot_id=${telegramConfig.botId}&btn_text=${btnText}`"></iframe>
  </div>
</template>

<script>
import { TELEGRAM_VERIFY } from '@/store/sso-auth.module';
import { SHARED } from "@/constants/constants";
import { locale, uiHelper } from "@/util";
export default {
  name: "telegramLoginButton",
  props: {
    mode: {
      type: String,
      required: false,
      default: 'login'
    },
  },
  mounted() {
    window.addEventListener('message', this.iframeMessageListener, false);
  },
  destroyed() {
    window.removeEventListener('message', this.iframeMessageListener, false);
  },
  data() {
    return {
      telegramConfig: {...this.$store.state.ssoAuth.telegramConfig},
      loginFired: false
    }
  },
  computed: {
    telegramConfigResult() {
      return !!this.$store.state.ssoAuth.telegramConfig.botId
    },
    ssoRegisterRegType() {
      return this.$store.state.ssoAuth.ssoRegisterData.regType
    },
    btnText() {
      return this.mode === 'register' ? locale.getMessage('button.registerWithTelegram') : locale.getMessage('button.loginWithTelegram')
    },
    isAndroidWebview() {
      return uiHelper.isAndroidWebView()
    }
  },
  watch: {
    telegramConfigResult() {
      this.telegramConfig = {...this.$store.state.ssoAuth.telegramConfig}
    },
    ssoRegisterRegType() {
      if (this.$store.state.ssoAuth.ssoRegisterData.regType == SHARED.LOGIN_TYPE_TELEGRAM) {
        this.openRegister()
      }
    },
  },
  methods: {
    telegramLogin() {
      document.getElementById("telegramLoginIframe").contentWindow.document.getElementById("telegramLoginButton").click();
    },
    openRegister() {
      this.$emit('openRegister')
    },
    iframeMessageListener(e) {
      const key = e.message ? 'message' : 'data';
      const data = e[key];
      if (data && data.action === 'telegramLoginResult') {
        if (data.telegramUser) {
          this.$store.dispatch(`${TELEGRAM_VERIFY}`, {telegramUser: data.telegramUser})
        } else {
          this.$emit('error', data.message)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">

.telegram-login-button-container {
  background: transparent linear-gradient(180deg, #54A9EB 0%, #0E68AE 86%, #0E68AE 100%) 0% 0% no-repeat padding-box;
  color: #FFFFFF;
  font: normal normal 600 16px/25px;
  border-radius: 5px;
  opacity: 1;

  font-size: 16px;
  @media screen and (max-width: 959px) {
    font-size: 14px;
  }
  font-weight: 400;

  height: 48px;
  margin-top: 12px;
  border-radius: 14px;
  overflow: hidden;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
}
.telegram-login-icon {
  width: 30px;
  height: 30px;
  img {
    width: 30px;
    height: 30px;
  }
}
</style>